"use client";

import React from "react";
import { Link } from "@/components/common/Link";
import { Card, CardHeader, CardTitle, CardContent } from "@/components/ui/card";
import { ChevronRight } from "lucide-react";
const services = [{
  title: "Die Körperanalyse",
  description: "Hier wird der Ist-Zustand des Körpers analysiert. Besonders spannend ist die Feststellung des \"biologischen Alters\", das durchaus mehr als 10 Jahre vom tatsächlichen Alter abweichen kann - sowohl nach oben als auch nach unten. Die Zellvitalität wird ermittelt. Außerdem messen wir das Körperwasser und stellen so fest, ob man genug trinkt. Fett und Muskelmasse werden ebenso geprüft.",
  link: "/ServiceSubpagesPage",
  tag: "Vitality"
}, {
  title: "Die Bewei Liege",
  description: "Die Behandlung erfolgt bekleidet auf einer Komfort-Liege – auf Wunsch inklusive sanfter Rückenmassage. Während du entspannst, regen sanfte elektromagnetische Wellen deinen Stoffwechsel und die Durchblutung an, was dein Hautbild sichtbar verbessert.",
  link: "/ServiceSubpagesPage",
  tag: "Strength"
}, {
  title: "Die Lymphdrainage",
  description: "Als ideale Ergänzung erfolgt vor oder nach deiner BEWEI-Anwendung eine sanfte Druckwellen-Massage. Entspannt und bekleidet genießt du in unserer Lymph-Hose einen rhythmischen Luftdruck, der dein Lymphsystem gezielt aktiviert.\n\n\nLindas Vital-Tipps:\nTrinke täglich 2 Liter Wasser oder Tee und starte mit lauwarmem Zitronenwasser in den Tag. 30 Minuten Bewegung runden den Effekt perfekt ab.",
  link: "/ServiceSubpagesPage",
  tag: "Radiance"
}];
export default function OurCoreServices() {
  return <section data-section-id="238152" id="solutions-grid" className="bg-background text-foreground">
      <div className="bg-[#FAFAFA] dark:bg-muted/10 py-24 px-6 md:px-12 lg:px-24">
        <div className="max-w-7xl mx-auto">
          <div className="text-center mb-16">
            <h2 className="font-default font-bold !text-5xl !text-[rgba(21,165,150,1)]">Die Behandlung</h2>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            {services.map((service, i) => <Card key={service.title} data-index={i} className="text-card-foreground gap-6 p-12 border-0 shadow-lg transition-all duration-700 ease-in-out border-b border-transparent rounded-3xl bg-card flex flex-col relative overflow-hidden !h-[780px] lg:p-16 hover:-translate-y-2 hover:border-primary">
                <CardHeader className="p-0 mb-6">
                  <div className="relative inline-flex mb-8">
                    <span className="font-default relative z-10 !font-black !text-9xl !text-[rgba(215,251,246,1)]">
                      {i + 1}
                    </span>
                  </div>
                  <CardTitle className="font-default font-semibold text-foreground text-2xl">
                    {service.title}
                  </CardTitle>
                </CardHeader>
                
                <CardContent className="p-0 flex-grow">
                  <p className="text-muted-foreground font-sans font-light text-lg leading-relaxed">
                    {service.description}
                  </p>
                </CardContent>
              </Card>)}
          </div>
        </div>
      </div>
    </section>;
}